import { SpacingSize, StyleOverride } from '@/types/craft-style-overrides';
export type { SpacingSize, StyleOverride } from '@/types/craft-style-overrides';

const spacingClasses: Record<Exclude<SpacingSize, 'default'>, {
  mobile: string;
  tablet: string;
  desktop: string;
}> = {
  none: {
    mobile: 'mt-[0px] mb-[0px]',
    tablet: 'md:mt-[0px] md:mb-[0px]',
    desktop: 'lg:mt-[0px] lg:mb-[0px]'
  },
  small: {
    mobile: 'mt-[24px] mb-[24px]',
    tablet: 'md:mt-[32px] md:mb-[32px]',
    desktop: 'lg:mt-[48px] lg:mb-[48px]'
  },
  large: {
    mobile: 'mt-[88px] mb-[88px]',
    tablet: 'md:mt-[117px] md:mb-[117px]',
    desktop: 'lg:mt-[176px] lg:mb-[176px]'
  },
};

const buildMarginClass = (spacing: SpacingSize, direction: 'mt' | 'mb'): string => {
  if (spacing === 'default') {
    return '';
  }
  const classes = spacingClasses[spacing];

  return `${classes.mobile} ${classes.tablet} ${classes.desktop}`;
};

export const getResponsiveMarginClassesFromStyleOverride = (
  styleOverride: StyleOverride = {}
): string | null => {

  if (!styleOverride) {
    return null;
  }

  const topSpacing = styleOverride.topMarginSpacing ?? 'default';
  const bottomSpacing = styleOverride.bottomMarginSpacing ?? 'default';

  const topClass = buildMarginClass(topSpacing, 'mt');
  const bottomClass = buildMarginClass(bottomSpacing, 'mb');

  return [topClass, bottomClass].filter(Boolean).join(' ');
};

